import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { PermissionsService } from 'src/app/core/services/permissions/permission.service';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { DropDownOptions, IItemToRequest, MyPurchaseForm, StoreDropdowns, UserInformation } from 'src/app/shared/models/app-models';
import { EstimatedUsages } from 'src/app/shared/models/database-models/EstimatedUsages.model';


@Component({
  selector: 'app-capital-usage-requirements',
  templateUrl: './capital-usage-requirements.component.html',
  styleUrls: ['./capital-usage-requirements.component.scss']
})
export class CapitalUsageRequirementsComponent {
  @Input() isReadOnly: boolean = false;
  @Output() formData = new EventEmitter();
  toggle: boolean = false;
  @Input() addCapitalUsageRequirementForm!: FormGroup;
  estimatedUsages: EstimatedUsages[] = [];
  tooltipInfoSpaceRequirement: string = `If you are unsure if there is existing space allocated to your division/cluster, please check with your RPG.`;
  IsAdditionalSpaceRequired!: FormControl;
  EstimatedUsageId!:   FormControl;
  AnnualMaintenanceCost!:FormControl;
  IsSupportingNonFundingProject!: FormControl;
  SupportingInformation!:FormControl;
  mpNumber: string = '';
  reasonDescriptionReadOnly : boolean = false;
  form: IItemToRequest[] = [];
  mode: string = 'add';
  itemNo: number = 0;
  destroy$: Subject<boolean> = new Subject<boolean>();
  permissionData$:Observable<any>
  constructor(
    private _fb: FormBuilder,
    public router: Router,
    private store: Store<{
      form: MyPurchaseForm;
      dp: StoreDropdowns;
      user: UserInformation;
    }>,
    private route: ActivatedRoute,
    public materialDialog: MatDialog,
    private dialogRef: MatDialogRef<DialogComponent>,
    private permissionService:PermissionsService
  ) {
    this.permissionData$ = permissionService.getService().pipe(takeUntil(this.destroy$))
    this.mpNumber = this.route.snapshot.params['id'];
    this.itemNo = this.route.snapshot.params['itemNo'];
    this.mode = this.route.snapshot.params['itemNo'] ? 'edit' : 'add';
    if (this.mode === 'edit') {
      this.itemNo = this.route.snapshot.params['itemNo'];
    }
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.estimatedUsages = dp.EstimatedUsages || [];
      });
  }
  async ngOnInit(): Promise<void> {
    // controls
    this.IsAdditionalSpaceRequired = this.addCapitalUsageRequirementForm.controls['IsAdditionalSpaceRequired'] as FormControl;
    this.SupportingInformation = this.addCapitalUsageRequirementForm.controls['SupportingInformation'] as FormControl;
    this.EstimatedUsageId = this.addCapitalUsageRequirementForm.controls['EstimatedUsageId'] as FormControl;
    this.AnnualMaintenanceCost = this.addCapitalUsageRequirementForm.controls['AnnualMaintenanceCost'] as FormControl;
    this.IsSupportingNonFundingProject = this.addCapitalUsageRequirementForm.controls['IsSupportingNonFundingProject'] as FormControl;
    this.reasonDescriptionReadOnly = this.addCapitalUsageRequirementForm.controls['IsSupportingNonFundingProject'].getRawValue();

    this.store
    .select('form')
    .pipe(takeUntil(this.destroy$))
    .subscribe(async (form: MyPurchaseForm) => {
      this.form = form.ItemList;
      if (!this.addCapitalUsageRequirementForm) return;
      if (this.mode == 'edit' && this.form.length !== 0) {
        let item = this.form[this.itemNo - 1].AddItems;
        this.addCapitalUsageRequirementForm.setValue({
          IsAdditionalSpaceRequired: item.IsAdditionalSpaceRequired,
          EstimatedUsageId: item.EstimatedUsageId,
          // estimatedAssetId: item.CriticalityId
          //     ? this.deliveryAddressDropdown.find(
          //       (deliveryAddress) => deliveryAddress.value == item.estimatedAssetId?.value
          //     )
          //     : null,
          SupportingInformation:item.SupportingInformation,
          AnnualMaintenanceCost:item.AnnualMaintenanceCost,
          IsSupportingNonFundingProject:item.IsSupportingNonFundingProject
        });
      }
    });

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isReadOnly']) {
      if (changes['isReadOnly'].currentValue == true) {
        this.addCapitalUsageRequirementForm.disable();
      } else {
        this.addCapitalUsageRequirementForm.enable();
      }
    }
  }
  restrictNegativeNumberInput(event: Event, decimalPlaces?: number): void {
    const inputElement = event.target as HTMLInputElement;
    const enteredValue = parseFloat(inputElement.value);
    const decimalRegex = new RegExp(`^\\d*\\.?\\d{0,${decimalPlaces}}$`);
    if (inputElement.value.includes('.')) {
      const regex = new RegExp(`(\\.\\d{${decimalPlaces}})\\d+$`);
      inputElement.value = inputElement.value.replace(regex, '$1');
    }
    if (!decimalRegex.test(inputElement.value)) {
      inputElement.value = inputElement.value; // Revert to the last valid value
    } else if (inputElement.value.startsWith('0') && inputElement.value[1] !== '.') {
        inputElement.value = inputElement.value.replace(/^0+/, '');
    }
    if (isNaN(enteredValue)) {
      inputElement.value = '';
    }
  }

  IsSpaceRequirementControlChange(event: any) {
    this.IsAdditionalSpaceRequired.setValue(event.value)
  }
  IsProjectCofundingControlChange(event: any) {
    this.IsSupportingNonFundingProject.setValue(event.value)
    if(event.value === false){
      this.SupportingInformation.setValue('')
      this.reasonDescriptionReadOnly = true
    }else{
      this.reasonDescriptionReadOnly = false
    }
    
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
